(function () {
  'use strict';

  function reveal(section) {
    section.classList.add('is-revealed');
  }

  function initSection(section) {
    if (!section || section.nbv2ResultsInit) return;
    section.nbv2ResultsInit = true;

    if (!section.classList.contains('nbv2-results--animated')) return;

    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || typeof IntersectionObserver === 'undefined') {
      reveal(section);
      return;
    }

    var threshold = parseFloat(section.dataset.animationThreshold);
    if (isNaN(threshold) || threshold < 0 || threshold > 1) threshold = 0.2;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: threshold }
    );

    observer.observe(section);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-nbv2-results]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
